<div style="min-width:400px;">
  <div style="width:98%;">
    <span> <button class="btn btn border" (click)="saveInstitutionGroup()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Beskrivning
          </label>
          <input id="description" type="text" class="form-control form-control-sm" formControlName="description">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Primary
          </label>
          <input id="primary" type="text" class="form-control form-control-sm" formControlName="primary">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Managed
          </label>
          <input id="managed" type="text" class="form-control form-control-sm" formControlName="managed">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Terminal
          </label>
          <input id="terminal" type="text" class="form-control form-control-sm" formControlName="terminal">
        </div>
      </div>
    </form>
  </div>
</div>